(function () {
  'use strict';
  var S = window.themeStrings || {};

  /* Announcement rotator */
  document.querySelectorAll('[data-rotator]').forEach(function (track) {
    var items = track.children;
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* Mobile menu */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('MobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('hidden');
      if (open) nav.removeAttribute('hidden'); else nav.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Auto-submit selects / filters */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.matches('[data-autosubmit]')) return;
    var form = el.form;
    if (!form) return;
    if (form.id === 'CartForm') {
      form.querySelector('[name="update"]').click();
      return;
    }
    form.submit();
  });

  /* Login: toggle recover password */
  document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var r = document.getElementById('RecoverForm');
      var l = document.getElementById('LoginForm');
      if (!r || !l) return;
      r.hidden = !r.hidden;
      l.hidden = !l.hidden;
    });
  });
  if (location.hash === '#recover') {
    var rf = document.getElementById('RecoverForm');
    var lf = document.getElementById('LoginForm');
    if (rf && lf) { rf.hidden = false; lf.hidden = true; }
  }

  /* Quantity buttons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
    input.value = v;
  });

  /* Product gallery + variants */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var slides = section.querySelectorAll('.product__slide');
    var thumbs = section.querySelectorAll('[data-thumb]');
    function showMedia(id) {
      if (!id) return;
      var found = false;
      slides.forEach(function (s) {
        var match = String(s.dataset.mediaId) === String(id);
        if (match) found = true;
        s.classList.toggle('is-active', match);
      });
      if (!found && slides[0]) slides[0].classList.add('is-active');
      thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)); });
    }
    var activeSlide = section.querySelector('.product__slide.is-active');
    if (activeSlide) showMedia(activeSlide.dataset.mediaId);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var form = section.querySelector('[data-product-form]');
    if (!form) return;
    var select = form.querySelector('[data-variant-select]');
    var addBtn = form.querySelector('[data-add-button]');
    var priceWrap = section.querySelector('[data-price]');
    var moneyFormat = null;

    function formatMoney(cents) {
      var current = priceWrap && priceWrap.querySelector('.price__current');
      try {
        var cur = (document.documentElement.dataset.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }

    function selectedOptions() {
      return product.options.map(function (_, idx) {
        var checked = form.querySelector('input[name="option' + (idx + 1) + '"]:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = S.unavailable || 'Unavailable';
        return;
      }
      select.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? (S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out');
      if (priceWrap) {
        var cur = priceWrap.querySelector('.price__current');
        var cmp = priceWrap.querySelector('.price__compare');
        var priceEl = priceWrap.querySelector('.price');
        if (cur) cur.textContent = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (!cmp) { cmp = document.createElement('s'); cmp.className = 'price__compare'; priceEl.appendChild(cmp); }
          cmp.textContent = formatMoney(variant.compare_at_price);
          priceEl.classList.add('price--sale');
        } else {
          if (cmp) cmp.remove();
          priceEl.classList.remove('price--sale');
        }
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update();
    });
  });

  /* AJAX add to cart */
  var toast = document.getElementById('CartToast');
  var toastTimer;
  function showToast(text) {
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 3500);
  }
  function updateCount() {
    fetch((window.routes ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('js-add-to-cart')) return;
    if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var url = (window.routes ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { showToast(res.data.description || res.data.message || S.error); return; }
        showToast(S.added || 'Added');
        updateCount();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* Product recommendations */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    if (!el.dataset.url || el.children.length) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
        else el.remove();
      }).catch(function () {});
  });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.section-head, .card, .family, .perk, .pyramid__tier, .split__content').forEach(function (el) {
      el.classList.add('reveal');
      io.observe(el);
    });
  }
})();
